import { AnalyticsStore, codeSplit, Controller, FetchOptions, Result } from 'bernie-core';

import { PageData } from 'bernie-http';
import '../client/temp-common-imports';
import analyticsUtil from '../util/AnalyticsUtil';

export class SignUpController implements Controller {
  public pageId = 'SignUp';
  public path = '/:localeName/signup';
  public routeName = 'signup';
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "uis-prime-example-page" */ '../views/signup-page'));
  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    const { stores, request } = options;
    const analyticsStore: AnalyticsStore = stores && stores.get<AnalyticsStore>('analytics');

    const pageName = 'page.affhub.signup';
    const context = request.context;

    analyticsUtil.runAnalytics(pageName, analyticsStore, context);

    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Affiliate Hub Sign-up' }) as Promise<PageData>;
  }
}
